"use client";

import { AuthBootstrapper } from "@/components/auth/auth-bootstrapper";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { useState } from "react";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30 * 1000,
            retry: 1,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthBootstrapper />
      {children}
      <Toaster
        position="top-center"
        toastOptions={{
          className: "rounded-2xl shadow-2xl",
          style: {
            fontFamily: "var(--font-outfit), ui-sans-serif, system-ui, sans-serif",
          },
        }}
      />
    </QueryClientProvider>
  );
}
